export const apiBaseUrl = './membership/api/v1'
